module.exports = __webpack_public_path__ + "img/leg.88e8b1b5.svg";